var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-layout", [
    _c("div", { staticClass: "gx-main-content-wrapper" }, [
      _c("div", { staticClass: "gx-login-container" }, [
        _c(
          "div",
          { staticClass: "gx-login-content" },
          [
            _c("div", { staticClass: "gx-login-header gx-text-center" }, [
              _c("h1", { staticClass: "gx-login-title" }, [
                _vm._v("Forgotten Password")
              ]),
              _c("p", [
                _vm._v("Simply enter your email address below to reset it.")
              ])
            ]),
            _vm.status === "error"
              ? _c("a-alert", {
                  staticClass: "gx-mb-3",
                  attrs: { type: "error", message: _vm.message, banner: "" }
                })
              : _vm._e(),
            _c("a-input", {
              staticClass: "gx-mb-3",
              attrs: { type: "email", placeholder: "Email Address" },
              model: {
                value: _vm.email,
                callback: function($$v) {
                  _vm.email = $$v
                },
                expression: "email"
              }
            }),
            _c(
              "a-button",
              {
                attrs: { type: "primary", block: "", loading: _vm.isLoading },
                on: { click: _vm.resetPassword }
              },
              [_vm._v("Reset")]
            ),
            _c(
              "div",
              { staticClass: "gx-text-center" },
              [_c("router-link", { attrs: { to: "/" } }, [_vm._v("Go back")])],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }